import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  koKR,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getIcon } from 'src/utils/hex-to-rgba';
import CustomChip from '../../components/mui/chip';
import CustomNoRowsOverlay from '../../utils/CustomNoRowsOverlay';

const TableRecentView = ({list}) => {
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)

  const onPageSizeChange = e => {
    setPageSize(e.target.value)
  }

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const _page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Stack direction="row" spacing={2} sx={{ pr: 4, alignItems: 'center' }}>
        <InputLabel id="pagesize-select">행/페이지</InputLabel>
        <FormControl variant="standard" sx={{ mr: 1, minWidth: 70 }}>
          <Select
            labelId="pagesize-select"
            id="pagesize-select"
            value={pageSize}
            onChange={onPageSizeChange}
            label="pageSize"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          color="primary"
          count={pageCount}
          page={_page + 1}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
      </Stack>
    );
  }

  const columns = [
    {
      flex: 0.4,
      minWidth: 120,
      field: 'name',
      headerName: '상품명',
      renderCell: params => (
        <Link to={`/admin/product/item/${params.row.sku}`} >
          <Stack direction="row" spacing={4}>
            <Avatar alt="product" src={getIcon(params.row.icon1)} variant='rounded' sx={{ width: 34, height: 34 }} />
            <Typography variant='body2' sx={{ color: 'text.primary' }}>
              {params.row.name}
            </Typography>
          </Stack>
        </Link>
      )
    },    
    {
      flex: 0.2,
      minWidth: 20,
      field: 'count',
      headerName: '누적 클릭수',
      renderCell: params => (
        <CustomChip
          size='small'
          skin='light'
          color='primary'
          label={params.row.count}
          sx={{ '& .MuiChip-label': { textTransform: 'capitalize' } }}
          />
      )
    },
    {
      flex: 0.3,
      field: 'uptime',
      minWidth: 140,
      headerName: '최신 방문날짜',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.uptime.toLocaleString('ko-KR')}
        </Typography>
      )
    }
  ]

  return (
    <DataGrid
      sx={{
        ...(list.length == 0 && { minHeight: '300px' })
      }}
      localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
      autoHeight
      getRowId={row => row.id}
      pagination
      rows={list}
      rowCount={list.length}
      columns={columns}
      pageSize={pageSize}
      onPageChange={newPage => setPage(newPage)}
      components={{
        Pagination: CustomPagination,
        NoRowsOverlay: CustomNoRowsOverlay,
      }}
      disableSelectionOnClick
    />
  )
}

export default TableRecentView